export const MIXPANEL_EVENTS_UPLOAD = {
  MESH_UPLOAD_TOO_BIG: 'upload_too_big',
  MODEL_REFERENCE_UPLOAD_TOO_BIG: 'model_reference_upload_too_big'
}
